import React from 'react'
import IndexPage from '../index'

const IndexPageDe = () => {
    return <IndexPage languageCode="de" />
}

export default IndexPageDe
